import DataPicker from 'src/components/DataPicker';
import InternalHeader from '../../components/InternalHeader/InternalHeader';
import PatientBlockForTable from '../../components/TableElements/PatientBlockForTable/PatientBlockForTable';
import PractitionerBlock from 'src/components/PractitionerBlock/PractitionerBlock';
import CampusBlock from 'src/components/CampusBlock/CampusBlock';
import RipplePreloader from 'src/components/RipplePreloader';
import PractitionersSelect from 'src/views/practitioner/components/FiltersSection/PractitionersSelect';

export default {
  CampusBlock,
  DataPicker,
  InternalHeader,
  PatientBlockForTable,
  PractitionerBlock,
  PractitionersSelect,
  RipplePreloader
};